module.exports = __webpack_public_path__ + "img/bold-02.246b23ee.svg";